import * as actions from './firebase.actions'

const initialState = {
  token: {},
  uid: null,
  groupId: null,
  firebaseDbPath: '',
  userData: {},
  userMap: {},
  // Move this to another reducer ?
  listenerType: {
    name: '',
    storeName: 'userMap',
  },
  playerList: {},
  playersData: {},
  groupData: {
    session: 1,
    blocked: false,
  },
  federationsInfo: {},
}

const actionsMap = {
  // Save the firebase token
  [actions.FIREBASE_INITIALIZED]: (state, action) => {
    return {
      ...state,
      token: action.data.accessToken,
      uid: action.data.uid,
      groupId: action.data.groupId,
      firebaseDbPath: action.data.firebaseDbPath,
      federationsInfo: action.data.federationsInfo,
      userData: action.data.playerData,
    }
  },
  [actions.SET_LISTENER_TYPE]: (state, action) => {
    let data = action.data
    return {
      ...state,
      listenerType: {
        ...state.listenerType,
        ...data,
      },
    }
  },

  [actions.SET_PLAYER_LIST]: (state, action) => {
    return {
      ...state,
      playerList: {
        ...action.data,
      },
    }
  },
  [actions.SET_PLAYERS_DATA]: (state, action) => {
    return {
      ...state,
      playersData: {
        ...action.data,
      },
    }
  },
  [actions.SET_ACTIVE_PLAYER_LIST]: (state, action) => {
    return {
      ...state,
      connectedList: action.data,
    }
  },
  [actions.SET_GROUP_DATA]: (state, action) => {
    return {
      ...state,
      groupData: {
        ...state.groupData,
        ...action.data,
      },
    }
  },
  [actions.SET_USER_DATA]: (state, action) => {
    return {
      ...state,
      userData: {
        ...state.userData,
        ...action.data,
      },
    }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
